module.exports = __webpack_public_path__ + "static/cover-92c5606e407be358d49ed63105652ec7.jpg";